import React, { useState, useEffect } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';

const CookiePopup: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setShowPopup(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowPopup(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-slide-up">
      <div className="bg-dark-card border border-dark-border rounded-xl p-6 shadow-2xl">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-3">
            <FaCookie className="text-yellow-400 text-2xl" />
            <h3 className="text-white font-semibold text-lg">Consentement aux cookies</h3>
          </div>
          <button
            onClick={handleReject}
            className="text-gray-400 hover:text-white transition-colors"
            aria-label="Fermer"
          >
            <FaTimes />
          </button>
        </div>

        <p className="text-gray-300 text-sm mb-4">
          Nous utilisons des cookies pour améliorer votre expérience de navigation, analyser le trafic du site,
          et personnaliser le contenu. En cliquant sur "Tout accepter", vous consentez à notre utilisation des cookies.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={handleReject}
            className="px-4 py-2 bg-dark-surface hover:bg-dark-border text-white rounded-lg transition-colors text-sm font-medium"
          >
            Tout refuser
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-dark-bg rounded-lg transition-all text-sm font-semibold"
          >
            Tout accepter
          </button>
        </div>

        <a
          href="/cookies"
          className="text-yellow-400 hover:text-yellow-300 text-xs mt-3 inline-block"
        >
          En savoir plus sur notre politique des cookies
        </a>
      </div>
    </div>
  );
};

export default CookiePopup;

